<template>
    <div class="d-flex">
        <export-to-pdf-button
            variant="default"
            :href="pdfHref"
            v-if="params.data.type === 'PDF'"
        />
        <export-to-excel-button
            variant="default"
            :href="excelHref"
            v-if="params.data.type === 'EXCEL'"
        />
        <b-button
            variant="default"
            class="mr-1"
            @click="$bvModal.show(editModalId)"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button variant="default" @click="$bvModal.show(deleteModalId)">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal :id="deleteModalId" title="Delete Settings" @ok="deleteSettings">
            Are you sure you want to delete {{ this.params.data.name }}?
        </modal>
        <report-settings-modal
            :modalId="editModalId"
            :initialValues="initialValues"
            @submit="updateSettings"
        />
    </div>
</template>

<script>
import { saveAs } from 'file-saver';
import isNan from 'lodash/isNaN';

import API from '../../../api.jsx';
import ExportToExcelButton from '../../generic/export-to-excel-button/export-to-excel-button.vue';
import ExportToPdfButton from '../../generic/export-to-pdf-button/export-to-pdf-button.vue';

import Modal from '../../generic/modal/modal.vue';
import ReportSettingsModal, {
    PROPERTIES_MULTI_SELECT,
    MULTI_SELECT_INPUT,
} from './report-settings-modal.vue';
import { REPORT_SETTINGS_ENDPOINT } from '../../../endpoints';
export default {
    components: {
        Modal,
        ReportSettingsModal,
        ExportToExcelButton,
        ExportToPdfButton,
    },
    computed: {
        deleteModalId() {
            return 'delete-settings-' + this.params.data.id;
        },
        editModalId() {
            return 'edit-settings-' + this.params.data.id;
        },
        pdfHref() {
            return `${REPORT_SETTINGS_ENDPOINT(this.params.data.id)}pdf/`;
        },
        excelHref() {
            return `${REPORT_SETTINGS_ENDPOINT(this.params.data.id)}excel/`;
        },
        initialValues() {
            let settings = this.params.data && this.params.data.settings;
            if (settings) {
                settings = JSON.parse(settings);
                settings = settings.map((item) => {
                    if (item.type === PROPERTIES_MULTI_SELECT) {
                        const value = item.value
                            .split(',')
                            .map((item) => ({ property_id: Number(item) }));
                        return {
                            ...item,
                            value,
                        };
                    }
                    if (item.type === MULTI_SELECT_INPUT) {
                        const value = item.value.split(',').map((item) => item);
                        return {
                            ...item,
                            value,
                        };
                    }
                    return item;
                });
            }
            return {
                ...this.params.data,
                settings: settings || [],
            };
        },
    },
    methods: {
        deleteSettings() {
            this.params.deleteSettings &&
                this.params.deleteSettings(this.params.data);
        },
        updateSettings() {
            this.params.updateSettings && this.params.updateSettings();
        },
        async savePdf() {
            try {
                const response = await API.get(this.pdfHref, {
                    responseType: 'blob',
                });
                saveAs(response.data, this.getFilenameFromResponse(response));
            } catch (err) {
                const text =
                    !!err.response && !!err.response.data
                        ? await err.response.data.text()
                        : '';
                if (text.indexOf('not allowed') > -1) {
                    this.errorToast({
                        text: 'You are not allowed to access this resource',
                    });
                } else {
                    this.errorToast({ text: 'Could not save pdf' });
                }
            }
        },
        getFilenameFromResponse(response) {
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                return /filename="(?<filename>.*)"/.exec(contentDisposition)
                    ?.groups?.filename;
            }
        },
    },
};
</script>

<style>
</style>